import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Heart, MessageCircle, ShieldCheck, Moon, Sparkles } from 'lucide-react';
export function ProductSection() {
  const features = [{
    icon: ShieldCheck,
    text: 'El pacto de 3 reglas para que nadie se sienta presionado/a'
  }, {
    icon: Sparkles,
    text: 'El Semáforo (verde/amarillo/rojo) para avanzar sin vergüenza'
  }, {
    icon: Moon,
    text: 'Un plan noche por noche (10–20 min)'
  }, {
    icon: MessageCircle,
    text: 'Frases listas para iniciar sin “dar cringe”'
  }, {
    icon: Heart,
    text: 'Qué hacer si hoy hay Rojo (sin convertirlo en pelea)'
  }, {
    icon: BookOpen,
    text: 'Ritual semanal para no volver a cero'
  }];
  return <section className="py-24 bg-cream px-6" data-id="element-333">
      <div className="container mx-auto max-w-5xl" data-id="element-334">
        <div className="text-center mb-16" data-id="element-335">
          <span className="text-wine font-semibold tracking-widest uppercase text-sm mb-4 block" data-id="element-336">
            Presentamos
          </span>
          <h2 className="text-4xl md:text-6xl font-bold text-wine-dark mb-6 font-serif" data-id="element-337">
            7 Noches Para Volver a Tocarnos <br data-id="element-338" />
            <span className="text-3xl md:text-5xl italic font-normal text-wine/80" data-id="element-339">
              (Sin Vergüenza)
            </span>
          </h2>
          <p className="text-xl text-charcoal/70 max-w-2xl mx-auto" data-id="element-340">
            Una guía romántica de 7 días para novios (25+) que quieren volver a
            besarse, abrazarse y tocarse con calma sin presión, sin morbo, sin
            sentir que “tiene que terminar en algo”.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-341">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative" data-id="element-342">
            <div className="absolute inset-0 bg-wine/5 rounded-3xl transform rotate-3" data-id="element-343"></div>
            <img src="https://cdn.magicpatterns.com/uploads/bxzLiZV2Jtj2XGQN8mD5iv/PORTADAOFICIAL7NochesParaVolver.png" alt="Portada del libro digital" className="relative rounded-3xl shadow-2xl w-full max-w-md mx-auto transform -rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-344" />
          </motion.div>

          <div data-id="element-345">
            <h3 className="text-2xl font-bold text-wine-dark mb-8" data-id="element-346">
              Qué incluye (por dentro):
            </h3>
            <div className="space-y-6" data-id="element-347">
              {features.map((feature, idx) => <motion.div key={idx} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: idx * 0.1
            }} className="flex items-start gap-4 p-4 bg-white rounded-xl shadow-sm border border-cream-dark hover:border-amber/30 transition-colors" data-id="element-348">
                  <div className="bg-wine/10 p-2 rounded-lg" data-id="element-349">
                    <feature.icon className="w-6 h-6 text-wine" data-id="element-350" />
                  </div>
                  <span className="text-lg text-charcoal/80 font-medium pt-1" data-id="element-351">
                    {feature.text}
                  </span>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}